import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IframeComponent } from '@shared/components/iframe/iframe.component';
import { IframeURLPipe } from '@shared/components/iframe/iframe-url.pipe';
import { SafeURLModule } from '@core/pipes/safe-url/safe-url.module';
import { LocalLoaderComponent } from '@shared/components/loader/local-loader/local-loader.component';

@NgModule({
  imports: [CommonModule, SafeURLModule, LocalLoaderComponent, IframeComponent, IframeURLPipe],
  exports: [IframeURLPipe, IframeComponent],
})
export class IframeModule {}
